import React, { useEffect, useState } from "react";
import RoomPlanSelector from "./RoomPlanSelector";
import CreateRoomPlan from "./CreateRoomPlan";
import ScanRoomPlan from "./ScanRoomPlan";
import { useRouter } from "next/router";
import { gtmPageOnloadTracking, gtmClickTracking } from "@/utils";


interface RoomPlanOnboardingProps {
  designImage?: any;
  onCloseOverlay?: Function;
  handleOverlayBack?: Function;
  currentRoomType?: string;
  roomTypeDisplayName?: string;
  roomId?:string;
}


const RoomPlanOnboarding: React.FC<RoomPlanOnboardingProps> = ({designImage, onCloseOverlay, handleOverlayBack, currentRoomType, roomTypeDisplayName,roomId}) => {
    const router = useRouter();
    const [activeComponent, setActiveComponent] = useState('');
    const [isCreateRoomPage, setCreateRoomPage] = useState(true);

    const renderComponent = () => {
      switch (activeComponent) {
        case 'scanRoomPlan':
          return <ScanRoomPlan setActiveComponent={setActiveComponent} designImage={designImage} onCloseOverlay={onCloseOverlay} roomTypeDisplayName = {roomTypeDisplayName}/>;
        case 'createRoomPlan':
          return <CreateRoomPlan setActiveComponent={setActiveComponent} designImage={designImage} onCloseOverlay={onCloseOverlay} currentRoomType = {currentRoomType} isModelRequired={isCreateRoomPage} roomId={roomId}/>; 
        default:  
          return <RoomPlanSelector setActiveComponent={setActiveComponent} designImage={designImage} onCloseOverlay={onCloseOverlay} roomTypeDisplayName = {roomTypeDisplayName} handleOverlayBack={handleOverlayBack} />;
      }
    };

    useEffect( ()=> {
      if(router.query && router.query.createRoomPlan) {
        setActiveComponent('createRoomPlan');
        setCreateRoomPage(false);
      }
    }, [router.query.createRoomPlan]);

    useEffect(() => {
        gtmPageOnloadTracking({
          event: 'Onboarding screen page view',
          pageType: "Onboarding screen page"
        });
      }
    , []);
    
    return (
        <>
            {renderComponent()}
        </>
    );
};

export default RoomPlanOnboarding;
